import React from 'react';
import SearchBlock from "../components/searchBlock/SearchBlock";
import BookList from "../components/bookList/BookList";
import MainBookList from "../components/mainBookList/MainBookList";

const MainPage = () => {
    return (
        <div>
            <SearchBlock/>
            <MainBookList/>
        </div>
    );
};

export default MainPage;